import { render, staticRenderFns } from "./CardTitleSection.vue?vue&type=template&id=f1daa01c&lang=pug&"
import script from "./CardTitleSection.vue?vue&type=script&lang=js&"
export * from "./CardTitleSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CardTitleSection.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardTitle,
})
